import React, { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const BookingParts = ({ parts, setParts }) => {
  const navigateBooking = useNavigate();
  const { partId } = useParams();
  const [user] = useAuthState(auth);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const { _id, img, name, price, quantity } = parts;
  const newQuantity = parseInt(quantity);

  const onSubmit = async (data) => {
    const newParts = { ...parts };
    newParts.quantity = newParts.quantity - data.quantity;
    setParts(newParts);

    const url = `https://mbababd24.onrender.com/part/${partId}`;
    fetch(url, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(newParts),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("success", data);
        // toast("Update Quantity successfully!!!");
      });

    let from = "/dashboard";

    const newPrice = parseInt(price) * data.quantity;
    const part = {
      partsId: _id,
      partsName: name,
      name: data.customerName,
      email: data.email,
      phone: data.phone,
      address: data.address,
      price: newPrice,
      quantity: data.quantity,
      img: img,
    };
    // send to your database
    fetch("https://mbababd24.onrender.com/booking", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(part),
    })
      .then((res) => res.json())
      .then((inserted) => {
        if (inserted.insertedId) {
          toast.success("Products booking successfully");
          navigateBooking(from, { replace: true });

          reset();
        } else {
          toast.error("Failed to add the Products");
        }
      });
  };

  return (
    <div className="mt-2">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid grid-cols-1 justify-items-center text-accent"
      >
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text text-accent">Name</span>
          </label>
          <input
            type="text"
            value={user?.displayName || ""}
            className="input input-bordered w-full max-w-xs"
            {...register("customerName", {
              required: {
                value: true,
                message: "Name is Required",
              },
            })}
          />
          <label className="label">
            {errors.customerName?.type === "required" && (
              <span className="label-text-alt text-red-500">
                {errors.customerName.message}
              </span>
            )}
          </label>
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text text-accent">Email</span>
          </label>
          <input
            type="email"
            value={user?.email || ""}
            className="input input-bordered w-full max-w-xs"
            {...register("email", {
              required: {
                value: true,
                message: "Email is Required",
              },
            })}
          />
          <label className="label">
            {errors.email?.type === "required" && (
              <span className="label-text-alt text-red-500">
                {errors.email.message}
              </span>
            )}
          </label>
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text text-accent">Quantity</span>
          </label>
          <input
            type="number"
            placeholder="How many products do you want to buy?"
            className="input input-bordered w-full max-w-xs"
            {...register("quantity", {
              required: {
                value: true,
                message: "Quantity is Required",
              },
              min: {
                value: 1,
                message: "You can't booking less then 1 parts quantity",
              },
              max: {
                value: newQuantity,
                message: "You can't booking more then Available quantity",
              },
            })}
          />
          <label className="label">
            {errors.quantity?.type === "required" && (
              <span className="label-text-alt text-red-500">
                {errors.quantity.message}
              </span>
            )}
          </label>
          {errors.quantity?.type === "min" && (
            <span className="label-text-alt text-red-500">
              {errors.quantity.message}
            </span>
          )}
          {errors.quantity?.type === "max" && (
            <span className="label-text-alt text-red-500">
              {errors.quantity.message}
            </span>
          )}
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text text-accent">Phone</span>
          </label>
          <input
            type="number"
            placeholder="Your Phone Number"
            className="input input-bordered w-full max-w-xs"
            {...register("phone", {
              required: {
                value: true,
                message: "Phone is Required",
              },
            })}
          />
          <label className="label">
            {errors.phone?.type === "required" && (
              <span className="label-text-alt text-red-500">
                {errors.phone.message}
              </span>
            )}
          </label>
        </div>
        <div className="form-control w-full max-w-xs">
          <label className="label">
            <span className="label-text text-accent">Address</span>
          </label>
          <textarea
            type="textarea"
            placeholder="Your Address"
            className="textarea textarea-bordered w-full max-w-xs "
            {...register("address", {
              required: {
                value: true,
                message: "Address is Required",
              },
            })}
          />
          <label className="label">
            {errors.address?.type === "required" && (
              <span className="label-text-alt text-red-500">
                {errors.address.message}
              </span>
            )}
          </label>
        </div>
        <input
          className="btn w-full max-w-xs border-2 border-white shadow-2xl  text-accent capitalize bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold "
          type="submit"
          value="Booking Products"
        />
      </form>
    </div>
  );
};

export default BookingParts;
